import script from "./FormulasGodApeQuestItems.vue?vue&type=script&setup=true&lang=js"
export * from "./FormulasGodApeQuestItems.vue?vue&type=script&setup=true&lang=js"

import "./FormulasGodApeQuestItems.vue?vue&type=style&index=0&id=4c33c842&lang=scss"

const __exports__ = script;

export default __exports__